import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retried && !original.url.includes("/auth/")) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Něco se pokazilo. Zkuste to prosím znovu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  if (!e.response)
    return "Nepodařilo se spojit se serverem. Zkontrolujte prosím připojení k internetu a zkuste to za chvíli znovu.";
  const raw = e.response.data?.detail;
  const detail = raw == null ? null : formatApiErrorDetail(raw);
  const looksEnglish = detail && /\b(field|value|input|string|required|invalid|ensure|error)\b/i.test(detail) && !/[ěščřžýáíéůúťďň]/i.test(detail);
  if (detail && !looksEnglish) return detail;
  const s = e.response.status;
  if (s === 422 || s === 400) return "Zkontrolujte prosím vyplněné údaje a zkuste to znovu.";
  if (s === 429) return "Příliš mnoho pokusů za sebou. Počkejte prosím pár minut a zkuste to znovu.";
  if (s === 413) return "Soubor je příliš velký — maximální velikost je 50 MB.";
  if (s >= 500) return "Na naší straně se něco pokazilo. Zkuste to prosím za chvíli znovu.";
  return detail || "Něco se pokazilo. Zkuste to prosím znovu.";
}
